import { Controller } from "@hotwired/stimulus"

// Manages the repeating line item rows on the new custom invoice form: appends a
// fresh row from the <template> and removes a row (keeping at least one). Rows use
// array-style names (line_items[][...]) so no index renaming is needed on add.
export default class extends Controller {
  static targets = ["container", "template", "lineItem"]

  // The removal marker a read-only row carries (see #removeLineItem).
  static DESTROY_FIELD = "[name='create_simple_invoice[line_items][][_destroy]']"

  addLineItem() {
    this.collapseOpenLineItems()
    const row = document.importNode(this.templateTarget.content, true)
    this.containerTarget.appendChild(row)
  }

  // Collapse every existing row so the user can focus on the new one.
  collapseOpenLineItems() {
    this.lineItemTargets.forEach((el) => {
      const controller = this.application.getControllerForElementAndIdentifier(
        el,
        "invoice-line-item",
      )
      controller?.collapse()
    })
  }

  // An editable row expresses its removal by not being submitted at all. A read-only
  // row can't: it has no editable fields, so the server preserves it from the original
  // invoice and an absent one is indistinguishable from one that never reached us. Those
  // rows carry a _destroy marker instead — we set it and hide the row, so removal is
  // stated explicitly and anything unmarked is kept.
  removeLineItem(e) {
    if (this.activeLineItems().length <= 1) return

    const row = e.target.closest("[data-invoice-items-form-target='lineItem']")
    const destroyField = row.querySelector(this.constructor.DESTROY_FIELD)

    if (destroyField) {
      destroyField.value = "1"
      row.classList.add("hidden")
    } else {
      row.remove()
    }
  }

  // The rows still on the invoice: everything except the read-only ones already marked
  // for removal, which are hidden but still in the DOM so they can post their marker.
  activeLineItems() {
    return this.lineItemTargets.filter((el) => {
      const destroyField = el.querySelector(this.constructor.DESTROY_FIELD)
      return !destroyField || destroyField.value !== "1"
    })
  }
}
